//Implement "Scroll-To-Top" button. This is a button which appears as soon
//as the user has scrolled down the page a bit and scrolls back to the top
//when clicked.

export class ScrollToTop {

    private button: JQuery;

    constructor (button: JQuery) {
        this.button=button;
        $(window).scroll((ev)=>this.scrollEvent());
        button.on("click",(ev)=>this.clickEvent());
    }

    private clickEvent() {
        $("html,body").animate({scrollTop:0},1000);
        $('body')[0].focus({preventScroll:true});
    }

    private scrollEvent() {
        var threshold=window.innerHeight/2;
        var scrollTop=$(window).scrollTop();
        if (scrollTop===undefined) return;
        this.button.css({'opacity':(scrollTop>threshold)?1:0});
    }

}

export {};